import { apiGateway } from "../api";

async function getFranchise(body) {
    try {
        const response = await apiGateway.post('/interodonto/franquia/valores/consultar', body);

        return response.data.procedimentos;

    } catch (error) {
        return error;
    }
}

export { getFranchise };